var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRuby = function SvgRuby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ruby_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.578 33.001 10.95 50l37.066-2.515 2.855-37.375-11.294 22.892Z",
    fill: "url(#ruby_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.077 47.457 44.892 25.47l-8.678 11.458 11.863 10.53Z",
    fill: "url(#ruby_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.12 47.461 24.782 45.63l-13.706 4.325 37.046-2.493Z",
    fill: "url(#ruby_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.108 49.957 5.83-19.102L4.109 33.6l7 16.358Z",
    fill: "url(#ruby_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.211 36.99-5.365-21.013-15.353 14.391 20.718 6.623Z",
    fill: "url(#ruby_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.654 16.275 35.141 4.422 31.1 17.488l18.554-1.213Z",
    fill: "url(#ruby_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.867.196-8.535 4.717-5.386-4.78 13.921.063Z",
    fill: "url(#ruby_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.732 40.005 3.576-6.521-2.892-7.77-.684 14.291Z",
    fill: "url(#ruby_svg__i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.224 25.47 2.91 8.256 12.645-2.837L31.217 17.47 35.29 4.53 28.876 0 17.968 4.082c-3.436 3.196-10.104 9.52-10.344 9.639-.238.121-4.404 7.994-6.4 11.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.442 10.64C18.89 3.255 28.49-1.108 32.175 2.61c3.683 3.717-.222 12.752-7.67 20.134-7.448 7.381-16.93 11.985-20.612 8.267-3.684-3.715.101-12.99 7.549-20.371Z",
    fill: "url(#ruby_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.108 49.95 5.785-19.16 19.213 6.171c-6.947 6.514-14.673 12.02-24.998 12.99Z",
    fill: "url(#ruby_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.241 17.433 4.932 19.536c5.803-6.101 11.011-12.66 13.562-20.774L31.24 17.433Z",
    fill: "url(#ruby_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.685 16.293c1.974-5.957 2.43-14.503-6.879-16.09L35.17 4.422l14.516 11.87Z",
    fill: "url(#ruby_svg__m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.732 39.919c.274 9.832 7.367 9.978 10.389 10.065l-6.98-16.3-3.409 6.235Z",
    fill: "#9E1209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.27 17.465c4.458 2.74 13.445 8.244 13.627 8.346.283.159 3.875-6.056 4.69-9.569l-18.318 1.223Z",
    fill: "url(#ruby_svg__n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.886 30.79 7.733 14.92c4.573-2.48 8.154-5.502 11.434-8.739L16.886 30.79Z",
    fill: "url(#ruby_svg__o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11 33.706 3.015 46.754c2.067 2.824 4.912 3.07 7.895 2.85-2.158-5.373-6.47-16.115-6.8-15.898Z",
    fill: "url(#ruby_svg__p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.124 4.457 15.363 2.156c-.82-3.475-3.337-5.717-7.63-6.418l-7.733 4.262Z",
    fill: "url(#ruby_svg__q)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__b",
    x1: 44.784,
    y1: 54.547,
    x2: 34.207,
    y2: 35.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E42B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__c",
    x1: 50.053,
    y1: 38.858,
    x2: 36.421,
    y2: 29.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__d",
    x1: 39.146,
    y1: 55.115,
    x2: 25.515,
    y2: 45.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__e",
    x1: 10.525,
    y1: 32.237,
    x2: 12.638,
    y2: 45.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E57252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE3B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A60003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__f",
    x1: 25.06,
    y1: 19.412,
    x2: 25.838,
    y2: 33.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E4714E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BE1A0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__g",
    x1: 37.958,
    y1: 6.459,
    x2: 40.289,
    y2: 16.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E46342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C82410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__h",
    x1: 30.841,
    y1: 2.922,
    x2: 40.885,
    y2: -2.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C81F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BF0905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF0905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__i",
    x1: 1.72,
    y1: 28.735,
    x2: 2.547,
    y2: 37.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DE4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BF190B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF190B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__j",
    x1: -3.963,
    y1: 39.249,
    x2: 34.9,
    y2: -0.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C82F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#820C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A31601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B31301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E82609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E82609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__k",
    x1: 25.805,
    y1: 43.283,
    x2: 14.099,
    y2: 40.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#990C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__l",
    x1: 45.91,
    y1: 29.232,
    x2: 35.511,
    y2: 19.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E110B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E0C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E0C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__m",
    x1: 49.731,
    y1: 12.129,
    x2: 44.551,
    y2: 6.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79130D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E120B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E120B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__p",
    x1: 7.481,
    y1: 49.939,
    x2: 3.26,
    y2: 35.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9E100A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B3100C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3100C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby_svg__q",
    x1: 39.867,
    y1: 2.48,
    x2: 49.331,
    y2: 6.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#910F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#791C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791C12"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ruby_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.131 20.09) scale(12.7436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7E0E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E0E08"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ruby_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.483 36.886) scale(16.9409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A30C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#800E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800E08"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ruby_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.732)",
    d: "M0 0h50.139v50H0z"
  })))));
};

export default SvgRuby;